export const APIURL = "https://rickandmortyapi.com/api";

export const DARKMODE = "darkMode";

export const EPISODE = "Episode";
export const EPISODELOWER = "episode";
export const EPISODESLOWER = "episodes";

export const LOCATION = "Location";
export const LOCATIONLOWER = "location";

export const CHARACTERLOWER = "character";
export const CHARACTERS = "Characters";
export const CHARACTERSLOWER = "characters";

export const STATUS = "Status";
export const SPECIES = "Species";
export const GENDER = "Gender";

export const FILTEROPTIONS = {
  STATUS: ["Alive", "Dead", "Unknown"],
  SPECIES: [
    "Human",
    "Alien",
    "Poopybutthole",
    "Mythological",
    "Animal",
    "Disease",
    "Robot",
    "Cronenberg",
    "Unknown",
  ],
  GENDER: ["female", "male", "genderless", "unknown"],
};
